import React from 'react';

const EmptyState = ({ icon, title, description, action }) => {
  return (
    <div className="bg-white/70 backdrop-blur-sm border border-dashed border-purple-200 rounded-2xl p-10 text-center shadow-inner">
      <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center text-purple-600">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 max-w-xl mx-auto mb-6">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="px-6 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold hover:from-purple-700 hover:to-pink-700 transition-all"
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;

